// Per-user experiment flag gating who may see or edit Tinuiti's booked CPM. Enforced server-side too.
export const PRINCIPAL_PRICING_FLAG = 'principalPricing';

export const NEXXEN_LINE_ITEMS_FLAG = 'enableNexxenStreamingLineItems';
// Gates activating line items from BPM, which starts spend on Nexxen.
export const NEXXEN_ACTIVATION_FLAG = 'enableNexxenActivation';
